import React from "react";
import {OrganizationUnit, OrganizationUnitRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";

export const OrganizationUnitEditPage = () => {
    const manager = useApiManager();
    const ctrl = manager.factory(OrganizationUnitRestControllerApiFactory);
    

    const form = useForm({
        fetcher: (id) => ctrl.getOrganizationUnit(id),
        updater: (bean) => ctrl.saveOrganizationUnit(bean),
        remover: (id) => ctrl.deleteOrDismissOrganizationUnit(id),
        factory: () => {
            return { } as OrganizationUnit;
        },
    } as UseFormProps<OrganizationUnit>);

    return (
        <>
            <FormContent form={form} title={"Ficha de la Unidad Organizativa"}>
                <Grid container spacing={3}>
                    <Grid item sm={3}>
                        <FormInput field={"name"} type={"text"} label={"Nombre"} />
                    </Grid>
                    <Grid item sm={3}>
                        <FormAutocomplete field={"parent"} type={types.organizationUnits} label={"Unidad superior"}/>
                    </Grid>
                    <Grid item sm={6}>
                        <FormAutocomplete field={"manager"} type={types.people} label={"Manager"}/>
                    </Grid>
                </Grid>
                <FormInput type={"text"} field={"description"} label={"Descripción"} />
            </FormContent>
        </>
    );
};